import { createAsyncThunk } from '@reduxjs/toolkit'
import PurchasableItem from './purchasable-item-model'
import {
  delete_purchasableItem,
  load_purchasableItems,
  store_purchasableItem,
} from './purchasableItem-service'

export const LoadPurchasableItemsAsync = createAsyncThunk<any, any>(
  'composer/load/purchasableItem',
  async (params: { uid: string }) => {
    return await load_purchasableItems(params)
  },
)

export const CreatePurchasableItemAsync = createAsyncThunk<any, any>(
  'composer/create/purchasableItem',
  async (params: PurchasableItem) => {
    return await store_purchasableItem(params)
  },
)

export const DeletePurchasableItemAsync = createAsyncThunk<any, any>(
  'composer/delete/purchasableItem',
  async (params) => {
    return await delete_purchasableItem(params)
  },
)
